import CircleExclammationIcon from '@src/svgs/CircleExclammationIcon';
import CloseIcon from '@src/svgs/CloseIcon';
import { useState } from 'react';
import styled from 'styled-components';

export const PaymentFailedBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const handleDismiss = () => setDismissed(true);

  return (
    <BannerWrapper>
      <Banner role="alert" data-testid="payment-failed-banner">
        <IconWrapper>
          <CircleExclammationIcon
            width="20"
            height="20"
            strokeColor="var(--destructive)"
          />
        </IconWrapper>
        <Message>
          Failed payment, please refer to the email from billing@tryarbor.com to
          avoid interrupted platform use.
        </Message>
        <CloseButton
          type="button"
          onClick={handleDismiss}
          aria-label="Dismiss payment failed notice"
        >
          <CloseIcon width={12} height={12} strokeColor="var(--destructive)" />
        </CloseButton>
      </Banner>
    </BannerWrapper>
  );
};

const BannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`;

const Banner = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background-color: color-mix(in srgb, var(--destructive) 10%, transparent);
  border: 1px solid var(--destructive);
  border-radius: 8px;
  color: var(--destructive);
  font-size: var(--text-sm);
`;

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

const Message = styled.span`
  font-weight: var(--font-weight-medium);
`;

const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-left: 4px;
  padding: 0;
  background: none;
  border: none;
  border-radius: 4px;
  color: var(--destructive);
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background-color: color-mix(in srgb, var(--destructive) 15%, transparent);
  }
`;
